import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { getSingleMymeAPI } from '@myme/api';
import { getSingleMyme } from '@myme/logic';
import { useDetectDevice, useMediaQuery, useUnmount } from 'src/hooks';
import { mymeEditorBlockedPageRoute } from 'src/routes/route-list';
import { useMymeEditor } from './context';
import { MymeEditorProvider } from './context/MymeEditorContext';

export const EditorContextWrapper = () => {
  const matchesSmallerResolution = useMediaQuery('md');
  const { isMobile } = useDetectDevice();
  const navigate = useNavigate();

  if (isMobile || matchesSmallerResolution) {
    navigate(mymeEditorBlockedPageRoute);
  }

  return (
    <MymeEditorProvider>
      <EditorDataWrapper />
    </MymeEditorProvider>
  );
};

interface Params {
  mymeId?: string;
}

const EditorDataWrapper = () => {
  const {
    dispatchClearMymeEditor,
    dispatchSetInitialMymeData,
    editor: { isCreator }
  } = useMymeEditor();
  const { mymeId }: Params = useParams();

  const shouldEnableGetMymeData = Boolean(!isCreator && mymeId);

  const singleMymeData = useQuery(
    [...getSingleMymeAPI.cacheKeys, mymeId],
    async () => {
      if (mymeId) {
        return getSingleMyme(mymeId);
      }

      return null;
    },
    {
      enabled: shouldEnableGetMymeData,
      refetchOnWindowFocus: false
    }
  );

  useEffect(() => {
    if (singleMymeData.data) {
      dispatchSetInitialMymeData(singleMymeData.data.data);
    }
  }, [singleMymeData.data]);

  useUnmount(() => {
    dispatchClearMymeEditor();
  });

  return <Outlet />;
};
